import { React } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { PageTransitionPropTypes } from "./propTypes";

const animations = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        animate="animate"
        className="z-1"
        exit="exit"
        initial="initial"
        key={location.pathname}
        transition={{ duration: 0.2, ease: "easeInOut" }}
        variants={animations}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

PageTransition.propTypes = PageTransitionPropTypes;

export default PageTransition;
